import React from 'react'

type Props = {
  name: string
  numberMasked?: string
  expiry?: string
  brand?: 'visa' | 'mastercard' | 'amex' | 'elo' | 'hipercard' | 'default'
  animateName?: boolean
}

export default function CreditCardPreview({ name, numberMasked, expiry, brand = 'default', animateName = false }: Props) {
  const mask = numberMasked || '•••• •••• •••• ••••'
  const exp = expiry || 'MM/AA'
  const brandLabel = (brand?.toUpperCase() || 'CARD') as string

  return (
    <div className="relative w-full overflow-hidden rounded-2xl border border-border/60 bg-gradient-to-br from-slate-800 to-slate-900 p-4 text-slate-50 shadow-xl dark:from-slate-800 dark:to-slate-900">
      <div className="absolute -top-16 -left-10 h-40 w-40 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute -bottom-16 -right-10 h-40 w-40 rounded-full bg-teal-400/20 blur-2xl" />

      <div className="flex items-center justify-between">
        <div className="text-xs opacity-70">PLATINUM</div>
        <div className="text-sm font-semibold tracking-wide opacity-90">{brandLabel}</div>
      </div>

      <div className="mt-4 select-none text-xl tracking-widest">
        {mask}
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
        <div className="opacity-70">NOME</div>
        <div className="opacity-70">VALIDADE</div>
        <div className={`text-sm font-medium tracking-wide transition-shadow duration-300 ${animateName ? 'ring-2 ring-teal-400/60 rounded px-1 shadow-[0_0_12px_rgba(16,185,129,0.35)]' : ''}`}>{name || 'NOME COMPLETO'}</div>
        <div className="text-sm font-medium">{exp}</div>
      </div>
    </div>
  )
}

